<script>
	import logo from './logoDLS.png';
</script>

<img src={logo} alt="logo" />
<div class="container">
	<a href="/self-enroll/" class="plan">
		<svg fill="currentColor" display="inline-block" viewBox="0 0 16 16">
			<path
				d="M9.293 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.707A1 1 0 0 0 13.707 4L10 .293A1 1 0 0 0 9.293 0M9.5 3.5v-2l3 3h-2a1 1 0 0 1-1-1m1.354 4.354-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 1 1 .708-.708L7.5 9.793l2.646-2.647a.5.5 0 0 1 .708.708" />
		</svg>
		Find a Plan
	</a>

	<a href="/ede/app/" class="consumer">
		<svg fill="currentColor" display="inline-block" viewBox="0 0 16 16">
			<path
				d="M7 14s-1 0-1-1 1-4 5-4 5 3 5 4-1 1-1 1zm4-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6m-5.784 6A2.24 2.24 0 0 1 5 13c0-1.355.68-2.75 1.936-3.72A6.3 6.3 0 0 0 5 9c-4 0-5 3-5 4s1 1 1 1zM4.5 8a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5" />
		</svg>
		For Consumers
	</a>

	<a href="/portal/" class="agent">
		<svg fill="currentColor" display="inline-block" viewBox="0 0 16 16">
			<path
				d="M8 1a5 5 0 0 0-5 5v1h1a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V6a6 6 0 1 1 12 0v6a2.5 2.5 0 0 1-2.5 2.5H9.366a1 1 0 0 1-.866.5h-1a1 1 0 1 1 0-2h1a1 1 0 0 1 .866.5H11.5A1.5 1.5 0 0 0 13 12h-1a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1h1V6a5 5 0 0 0-5-5" />
		</svg>
		For Agents
	</a>
</div>

<style>
	svg {
		display: block;
		width: 50px;
	}
	.plan {
		background: #d6154566;
	}
	.consumer {
		background: #d615c666;
	}
	.agent {
		background: #9915d666;
	}
	img {
		max-width: 200px;
		display: block;
		margin: auto;
	}
	a {
		color: inherit;
		display: flex;
		flex-flow: column;
		justify-content: center;
		align-items: center;

		gap: 16px;

		width: 200px;
		height: 200px;
		border-radius: 24px;
		font-size: 1.2em;
	}
	.container {
		display: flex;
		flex-flow: row wrap;
		justify-content: center;
		align-items: center;

		gap: 46px;

		position: relative;
		top: 0;
		left: 0;
		width: 100vw;
		min-height: 100vh;
	}
	@media (max-width: 800px) {
		.container {
			flex-flow: column;
		}
	}
</style>
